var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonBell = function SvgButtonBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    preserveAspectRatio: "none",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFCE41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.5 22.9 1.5-2.3s-2.7-8.4 3.9-9.6 5.8 9 5.8 9l1.8 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4 22.6c.1 1.1 1.1 2 2.2 2 1.3 0 2.3-1 2.3-2.2v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 6.3h-3l3.2 19.1-18.7 1.1V6.3H4.5v.6l-.8 22.9 25.8-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1 9.9H28V6.3L14.9.2.5 7.2z"
  }))));
};
export default SvgButtonBell;